<template>
  <div>
    <k-btn flat @click="load_previous_day">&lt; PREVIOUS DAY</k-btn>
  	<div v-for="(events, date) in grouped_events" class="day-group">
   		<div class="day-header">{{format_date_with_weekday(date)}}</div>
      <template v-if="tile_dashboard">
        <template v-for="(list, index) in sorted(events)">
          <dashboard-tile-event-group :events="list" :key="list[0].event_group.uuid" @changed="update_event_list"></dashboard-tile-event-group>
        </template>
      </template>
  	</div>
    <k-btn flat @click="load_next_day">NEXT DAY &gt;</k-btn>
    <action-buttons @add="open_add_event">
      <k-btn v-tooltip.bottom="'Filter own events'" size="m" v-if="$is_admin()" icon icon-name="filter" @click="filter_own_events = !filter_own_events"></k-btn>
    </action-buttons>

  </div>
</template>

<script>
import datelib from '@/lib/date.js';
import moment from 'moment';
import strftime from 'strftime';
import EventSearch from './Search'
import Vue from 'vue';
import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js';
import ActionButtons from '@/components/ActionButtons.vue'
import DashboardTileEventGroup from './TileEventGroup.vue'

export default {
  filters: datelib,
  components: {
    DashboardTileEventGroup,
    EventSearch,
    ActionButtons
  },
  data () {
  	var start_date = moment().startOf('day').toDate();
	  var end_date = moment().add(7, 'days').endOf('day').toDate();
    return {
      event_search: "",
      search_menu: false,
    	headers: [],
      channel: undefined,
      events: [],
      grouped_events: [],
      events_by_uuid: {},
      filter_own_events: false,
      tile_dashboard: true,
      filters: {
        daterange: {
          start: start_date,
          end: end_date
        },
        states: ["active"]
      },
  	}
  },
  computed: {
  },
  mounted: function() {
    this.$nextTick(function() {
      this.connect_ws();
    });
  },

  watch: {
    "filter_own_events" (newVal, oldVal) {
      var self = this;
      Vue.nextTick(function () {
        self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
      });
    }
  },

  methods: {
    update_event_list () {
      this.$nextTick(function() {
        this.filterEvents();
      });
    },
    load_previous_day () {
      this.filters.daterange.start = moment(this.filters.daterange.start).subtract(1, 'days');
      this.filterEvents();
    },
    load_next_day () {
      this.filters.daterange.end = moment(this.filters.daterange.end).add(1, 'days');
      this.filterEvents();
    },
    get_grouped_events: function(events) {
      var self = this;
      var ret = {};

      var f_events = events;
      if (self.filter_own_events == true) {
        f_events = _.filter(events, function(event) {
          return EventModel.is_todo_list(event, self.$store.state.account);
        }); 
      }

      var linked_events = {}
      _.each(f_events, function(event) {
        var d = moment(event.cached_start_time * 1000).startOf('day').unix();

        if (typeof(ret[d]) == "undefined") ret[d] = {};
        if (typeof(ret[d][event.event_group.uuid]) == "undefined") ret[d][event.event_group.uuid] = [];
        ret[d][event.event_group.uuid].push(event);

        if (typeof(event.system_meta.linked_event) != "undefined") {
          var main_event = _.find(f_events, function(e) { return e.uuid == event.system_meta.linked_event; });
          if (typeof(main_event) != "undefined") {
            if (typeof(linked_events[main_event.event_group.uuid]) == "undefined") linked_events[main_event.event_group.uuid] = [];
            linked_events[main_event.event_group.uuid].push(event);
          }
        }
      });
      _.each(linked_events, function(l_events, event_group_uuid) {
        _.each(ret, function(event_groups, d) {
          if (typeof(event_groups[event_group_uuid]) != "undefined") {
            ret[d][event_group_uuid].push(...l_events);
          }
        });
      });
      return ret;
    },
    open_add_event () {
      this.$router.push("/dashboard/event_new");
    },
  	format_date (date) {
  		if (date == moment().startOf('day').unix()) return "Today";
  		return datelib.format_date(date);
  	},
    format_date_with_weekday (date) {
      if (date == moment().startOf('day').unix()) return "Today";
      return datelib.format_date_with_weekday(date);
    },
  	sorted(list) {
  		return _.sortBy(list, [function(l) {
        var sorted = _.sortBy(l, [function(o) { return o.cached_start_time; }]);
        return sorted[0].cached_start_time;
      }]);
  	},
  	filterEvents () {
      var self = this;
      var _filters = _.cloneDeep(this.filters);
      if(typeof(_filters.daterange.start) != "undefined") {
        _filters.daterange.start = moment(_filters.daterange.start).startOf('day').unix();
      }
      if(typeof(_filters.daterange.end) != "undefined") {
        _filters.daterange.end = moment(_filters.daterange.end).endOf('day').unix();
      }
      this.channel.push("filter_reply", _filters)
        .receive("ok", (msg) => {
          self.add_events_to_list(msg.events);
        })
        .receive("error", (msg) => {
          console.log("Event filter failed");
        });
    },
    is_between_dates(event) {
      var _filters = _.cloneDeep(this.filters);
      var start_date = moment(_filters.daterange.start).startOf('day').unix();
      var end_date = moment(_filters.daterange.end).endOf('day').unix();
      return (event.cached_end_time > start_date && event.cached_start_time < end_date);
    },
    add_event_to_list(event) {
      var self = this;
      if (event.state == "active" && self.is_between_dates(event) ) {
        Vue.set(self.events_by_uuid, event.uuid, event);
      } else {
        Vue.delete(self.events_by_uuid, event.uuid);
      }
    },
    add_events_to_list(events) {
      var self = this;
      _.each(events, function(event) {
        self.add_event_to_list(event);
      });

      Vue.nextTick(function () {
        self.grouped_events = self.get_grouped_events(events);
      });
    },
  	connect_ws () {
  		var self = this;
	    this.channel = this.$cloudserver.channel("events:all");
  	  this.channel.on("init", function(msg) {
      	self.filterEvents();
    	});

/*    	this.channel.on("events", function(msg) {
        self.add_events_to_list(msg.events);
    	});*/
    	this.channel.on("event-update", function(msg) {
        var event = msg.data;
        self.add_event_to_list(event);
        Vue.nextTick(function () {
          self.grouped_events = self.get_grouped_events(Object.values(self.events_by_uuid));
        });
    	});
    	this.channel.join();
  	}
  }
}
</script>

<style scoped>
.day-group {
  margin-top: 30px;
}
.day-header {
  position: sticky;
  top: 0;
  z-index: var(--ks-z-sticky, 1);
  margin-bottom: 8px;
  padding: 8px 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--ks-font-color-primary);
  background: var(--ks-background-color-light);
  border-left: 4px solid var(--ks-col-accent);
  border-bottom: 1px solid var(--ks-col-secondary);
  border-radius: 4px;
}
/* Masks the .content-body top padding so rows don't show through above the sticky header */
.day-header::before {
  content: "";
  position: absolute;
  left: -4px;
  right: 0;
  bottom: 100%;
  height: var(--ks-padding-2);
  background: var(--rich-black-D50);
}
</style>
